import { IUser } from '@/common/Auth';
import store from '@/store';
import Vue from 'vue';

Vue.mixin({
	computed: {
		isAgent() {
			const user: IUser | undefined = store.state.Auth.user;
			return user?.isAgent === 'true';
		},

		isAgency() {
			const user: IUser | undefined = store.state.Auth.user;
			return user?.isAgency === 'true';
		},

		isOrgAdmin() {
			const user: IUser | undefined = store.state.Auth.user;
			return user?.isAgent === 'true' && user?.isAgency === 'true';
		},
	},
});
